import { ChangeDetectorRef, Component, inject, OnInit, ChangeDetectionStrategy, DOCUMENT } from '@angular/core';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LocalizationService } from '../../../Services/localization-service';
import { SeoService } from '../../../Services/SeoService';
interface PrivacyModelItem {
  title: string;
  content: string;
  order: number;
}
interface PrivacyModel {
  items: PrivacyModelItem[];
}
@Component({
  selector: 'app-privacy-component',
  imports: [
    TranslatePipe
  ],
  templateUrl: './privacy-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './privacy-component.scss'
})
export class PrivacyComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly seoService = inject(SeoService);
  private readonly document = inject(DOCUMENT);
  private readonly localizationService = inject(LocalizationService);
  privacyModel: PrivacyModel = {
    items: [
      { title: this.translate.instant('PRIVACY_TITLE1'), content: this.translate.instant('PRIVACY_CONTENT1'), order: 1 },
      { title: this.translate.instant('PRIVACY_TITLE2'), content: this.translate.instant('PRIVACY_CONTENT2'), order: 2 },
      { title: this.translate.instant('PRIVACY_TITLE3'), content: this.translate.instant('PRIVACY_CONTENT3'), order: 3 },
      { title: this.translate.instant('PRIVACY_TITLE4'), content: this.translate.instant('PRIVACY_CONTENT4'), order: 4 },
      { title: this.translate.instant('PRIVACY_TITLE5'), content: this.translate.instant('PRIVACY_CONTENT5'), order: 5 },
      { title: this.translate.instant('PRIVACY_TITLE6'), content: this.translate.instant('PRIVACY_CONTENT6'), order: 6 },
      { title: this.translate.instant('PRIVACY_TITLE7'), content: this.translate.instant('PRIVACY_CONTENT7'), order: 7 },
      { title: this.translate.instant('PRIVACY_TITLE8'), content: this.translate.instant('PRIVACY_CONTENT8'), order: 8 },
      { title: this.translate.instant('PRIVACY_TITLE9'), content: this.translate.instant('PRIVACY_CONTENT9'), order: 9 },
      { title: this.translate.instant('PRIVACY_TITLE10'), content: this.translate.instant('PRIVACY_CONTENT10'), order: 10 },
      { title: this.translate.instant('PRIVACY_TITLE11'), content: this.translate.instant('PRIVACY_CONTENT11'), order: 11 },
      { title: this.translate.instant('PRIVACY_TITLE12'), content: this.translate.instant('PRIVACY_CONTENT12'), order: 12 },
    ]
  }


  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
      if (lang != '') {
        const canonicalUrl = `${this.document.location.origin}/${lang}/privacy`;
        this.seoService.updateCanonicalUrl(canonicalUrl);
        this.cdr.detectChanges();
      }
    });
  }

}